import React, { useMemo } from 'react';
import classNames from 'classnames';
import { Field, Form } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import InputField from 'components/InputField';
import useValidations from 'router/subrouters/Auth/hooks/useValidations';
import { Button } from 'ncoded-component-library';
import EmailField from 'components/EmailField';

import './MainInfoStep.styles.scss';
import './MainInfoStep.styles.responsive.scss';

export type MainInfoStepValues = {
  firstName: string;
  lastName?: string;
  email: string;
  companyName?: string;
};

type MainInfoStepProps = {
  className?: string;
  email?: string;
  onSubmit: (values: MainInfoStepValues) => Promise<void>;
};

const MainInfoStep: React.FC<MainInfoStepProps> = (props) => {
  const { className, email, onSubmit } = props;

  const classes = classNames('main-info-step', className);

  const initialValues = useMemo(() => ({ email }), [email]);

  const commonValidations = useValidations();

  const { t } = useTranslation();

  return (
    <Form
      initialValues={initialValues}
      onSubmit={onSubmit}
      render={({ handleSubmit, submitting }) => (
        <form onSubmit={handleSubmit} className={classes}>
          <h2>{t('toAccessLinkEnterDetails')}</h2>

          <div>
            <Field
              name="firstName"
              component={InputField}
              label={t('firstName')}
              required
              validate={commonValidations.name}
            />
            <Field
              name="lastName"
              component={InputField}
              label={t('lastName')}
              validate={commonValidations.lastName}
            />
          </div>

          <div>
            <EmailField required />
            <Field
              name="companyName"
              component={InputField}
              label={t('company')}
            />
          </div>

          <small>{t('verificationCodeWillBeSentToYourEmail')}</small>

          <div className="actions">
            <Button type="submit" disabled={submitting}>
              {t('sendCode')}
            </Button>
          </div>
        </form>
      )}
    />
  );
};

export default MainInfoStep;
